import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StatsService } from '@app/services/stats.service';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ITableRow } from '@common/models/Document/ITableRow';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-usage-stats',
  templateUrl: './usage-stats.component.html',
  styleUrls: ['./usage-stats.component.scss'],
  providers: [MessageService],
})
export class UsageStatsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() visible: boolean;
  startDate: Date | null = null;
  endDate: Date | null = null;
  maxDate: Date = new Date();
  isLoading: boolean = false;
  powerUsersData = [];
  powerUserSub: Subscription  = new Subscription();
  powerUserLoader:boolean=true;
  chatInfo:ITableRow;
  chatInfoloader:boolean=true;
  interactionsVsTime={'chart':{},'loader':true}
  // interactionsVsTimeLoader:boolean=true
  @Output() visibleChange = new EventEmitter<boolean>(); // Emits changes


  UsersVsTime={'chart':{},'loader':true}
  designationUsageVsTime={'chart':{},'loader':true}


  constructor( private statsService: StatsService,
    private messageService: MessageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['visible'] && changes['visible'].currentValue){
      if(this.visible){
        this.setDefaultDates()
        this.getPowerUsers(10)
        this.getChatInfo()
        this.getInteractionVsTime()
        this.getUsersVsTime()}
    }
  }

  ngOnDestroy() {
    this.powerUserSub &&
    this.powerUserSub.unsubscribe();
  }

  ngOnInit() {
    if(this.visible){
      this.setDefaultDates()
      this.getPowerUsers(10)
      this.getChatInfo()
      this.getInteractionVsTime()
      this.getUsersVsTime()}
      // this.getDesignationUsageVsTime()
  }

  setDefaultDates() {
    const today = new Date();
    const twoWeeksAgo = new Date(today);
    twoWeeksAgo.setDate(today.getDate() - 14); // Subtract 14 days from today
    this.startDate = twoWeeksAgo;
    this.endDate = today;
}


formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed, so add 1
  const day = String(date.getDate()).padStart(2, '0');

  return `${day}/${month}/${year}`;
}

  loadCharts(){
      this.chatInfoloader=true
      this.getChatInfo()
      this.powerUserLoader=true
      this.getPowerUsers(10)
  }

  getPowerUsers(limit:number){
    this.powerUserSub.add(
      this.statsService.getPowerUsers(limit,this.formatDate(this.startDate),this.formatDate(this.endDate)).subscribe(
        (res: string[]) => {
          this.powerUserLoader=false
          this.powerUsersData=res
        },
        (error) => {
                this.powerUserLoader=false
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
          }
      )
    )
  }


  getChatInfo(){
    this.powerUserSub.add(
      this.statsService.getChatInfo(this.formatDate(this.startDate),this.formatDate(this.endDate)).subscribe(
        (res: ITableRow) => {
          this.chatInfoloader = false
          this.chatInfo = res
        },
        (error) => {
                this.chatInfoloader = false
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
          }
      )
    )
  }

  getInteractionVsTime(){
    this.powerUserSub.add(
      this.statsService.getInteractionVsTime().subscribe(
        (res: ITableRow) => {
          let title={ title: {
            text: 'Number of Interactions per quarter',
            top: '3%',
            left: '3%'
          },}
          res={...res,...title}
          this.interactionsVsTime['chart'] = res
          this.interactionsVsTime['loader'] = false
          this.addChatOptions(this.interactionsVsTime)
          // this.interactionsVsTimeLoader = false
        },
        (error) => {
          this.interactionsVsTime['loader'] = false

                // this.interactionsVsTimeLoader = false
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
          }
    )
    )
  }

  getUsersVsTime(){
    this.powerUserSub.add(
      this.statsService.getUsersVsTime().subscribe(
        (res: ITableRow) => {
          let title={ title: {
            text: 'Number of Users visiting per quarter',
            top: '3%',
            left: '3%'
          },}
          res={...res,...title}
          this.UsersVsTime['chart'] = res
          this.UsersVsTime['loader'] = false
          this.addChatOptions(this.UsersVsTime)

        },
        (error) => {
                this.UsersVsTime['loader'] = false
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
          }
        )
      )
    }

    getDesignationUsageVsTime(){
      this.powerUserSub.add(
        this.statsService.getDesignationUsageVsTime().subscribe(
          (res: ITableRow) => {
            // let title={ title: {
            //   text: 'Number of Users visiting per quarter',
            //  top: '3%',
            // left: '3%'
            // },}
            // res={...res,...title}
            this.designationUsageVsTime['chart'] = res
            this.designationUsageVsTime['loader'] = false
            this.addChatOptions(this.designationUsageVsTime)

          },
          (error) => {
                  this.designationUsageVsTime['loader'] = false
                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: 'Error',
                      detail: error.error.message,
                  });
            }
          )
        )
      }

    addChatOptions(chatResp:any){
      let options : ITableRow = {
        grid: {
          left: '10%',
          right: '10%',
          top: '20%',
          bottom: '25%',
        },
        tooltip: {
          trigger: 'axis'
        },
        dataZoom: [
          {
            type: 'slider',
            height: 15,
            xAxisIndex: 0,
            start: 0,
            end: 100,
            bottom: '12%',
          },
          {
            type: 'slider',
            width: 15,
            yAxisIndex: 0,
            start: 0,
            end: 100,
            left: '93%',
            bottom:'28%'
          }
        ],
        toolbox:{
          padding: 15,
          itemSize: 13,
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: {
              show : true
            }
          }
        }
      }
      chatResp.chart = {...chatResp.chart,...options}
    }


    closeDocumentsDialog() {
      this.visibleChange.emit(false);
  }

  isStartDateAfterEndDate(): boolean {
    if (!this.startDate || !this.endDate) {
      return false;
    }
    return this.startDate > this.endDate;
  }




}
